import { connect } from 'react-redux'
import { PrintPreviewViewport } from './PrintPreviewViewport.jsx'
import {
    determinePrintOrientation,
} from 'redux/print/actions'
import {
    getPrintOrientationAngle,
    getPreviewSheet,
    getPrintMediaTitle,
} from 'redux/print/selectors'

const mapStateToProps = (state, props) => ({
    previewSheet: getPreviewSheet(state, props.frame),
    printOrientationAngle: getPrintOrientationAngle(state),
    title: getPrintMediaTitle(state),
})

const mapDispatchToProps = (dispatch) => ({
    determinePrintOrientation: () => dispatch(determinePrintOrientation()),
})

export const PrintPreviewViewportContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(PrintPreviewViewport)
